<template>
  <div class="withdraw">
    <div class="title">
      提现流程
    </div>
    <div class="content">
      <a-form :form="form" :label-col="{ span: 2}" :wrapper-col="{ span: 19 }">
        <div v-show="currentProcess === 0 ">
          <a-form-item label="可提现金额">
            <b class="meter">¥</b><span class="money">{{ assets.property || 0 }}</span>
          </a-form-item>
          <a-form-item label="提现金额">
            <a-input

              placeholder="输入金额"
              v-decorator="['money',{
                rules:
                  [
                    {
                      required:true,
                      message: '*请输入提现金额'
                    },
                    { validator:checkDraw},
                  ],
                validateTrigger: ['submit'],
                getValueFromEvent: (event) => {
                  return event.target.value.replace(/^(0+)|[^\d]+/g,'')
                },
              }]"
              style="width:200px;height:40px;border-radius:8px"
            />
            <span style="margin-left:17px"> 元</span>
          </a-form-item>
          <a-form-item label="到账支付宝">
            <span>{{ userInfo.alipay_account }}</span>
          </a-form-item>
          <a-row style="margin-top:40px">
            <a-col :offset="2" >
              <a-button style="margin-left: 10px;" type="primary" @click="next">下一步</a-button>
            </a-col>
          </a-row>
        </div>

        <div v-show="currentProcess === 1 ">
          <a-form-item label="真实姓名：">
            <p>{{ userInfo.username }}</p>

          </a-form-item >
          <a-form-item label="到账支付宝：">
            <p>{{ userInfo.alipay_account }}</p>
          </a-form-item>
          <a-form-item label="提现金额">
            <p>{{ money }}</p>
          </a-form-item>
          <a-form-item label="缴税">
            <p>{{ tax_money }} <a-tooltip>
              <template slot="title">
                <p>应纳税所得额 = 提现金额（少于4000元） - 800元</p>
                <p>应纳税所得额 = 提现金额（超过4000元） × （1 - 20%）</p>
                <p>应纳税额 = 应纳税所得额 × 适用税率 - 速算扣除数</p>
                <p>说明：</p>
                <p>1、提现金额所得在800元以下的，不用缴纳个人所得税;</p>
                <p>2、提现金额所得大于800元且没有超过4000元，可减除800元的扣除费用;</p>
                <p>3、提现金额所得超过4000元的，可减除劳务报酬收入20%的扣除费用;</p>
              </template>
              <a-button type="link" style="color: #B3B9BF"><a-icon type="question-circle" /></a-button>
            </a-tooltip></p>
          </a-form-item>
          <a-form-item label="到账金额">
            <p>{{ real_money }}</p>

          </a-form-item>
          <a-form-item label="注册手机">
            <span >{{ phoneAddCode(userInfo.phone) }}</span>
            <a-button
              :disabled="codeState.sendBtn"
              :class="{'getCode-ing':codeState.isSend}"
              style="width: 130px; height:42px; border-radius:8px;margin-left:20px"
              v-text=" !codeState.isSend?'获取验证码': `${codeState.time}s`"
              @click.stop.prevent="getCode"
            >
            </a-button>

          </a-form-item>

          <a-row>
            <a-col :offset="2" :span="19">
              <a-form-item label="">
                <a-input

                  placeholder="验证码"
                  v-decorator="['code',{rules:[{
                    required:true,
                    message: '*请输入验证码'
                  }]}]"
                  style="width:234px;height:40px;border-radius:8px;padding-left:2px"
                >
                  <span
                    slot="prefix"
                    class="chatCode"

                  ></span>
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row style="margin-top:30px">
            <a-col :offset="2">
              <a-button style="margin-left: 10px" type="primary" @click="submit">确定提现</a-button>
              <a-button style="margin-left:30px;color:#B3B9BF;" type="default" @click="prev">返回修改</a-button>
            </a-col>
          </a-row>
        </div>

      </a-form>
    </div>
  </div>
</template>

<script>
import { phoneAddCode } from '@/utils/util.js'
export default {
  name: 'Withdraw',
  data () {
    return {
      form: this.$form.createForm(this),
      currentProcess: 0,
      codeState: {
        isSend: false,
        time: 60,
        status: 'success',
        errorText: ''
      },
      money: '', // 提现金额
      tax_money: '', // 缴税
      real_money: '', // 到账金额
      assets: {},
      timer: null,
      info: {}
    }
  },
  components: {

  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }

  },
  created () {
    this.$store.dispatch('GetInfo')
    this.getAssets()
  },
  methods: {
    phoneAddCode,
    getAssets () {
      this.$api.assets.getUserAssets().then(res => {
        if (res.status === 'ok') {
          this.assets = res.data
        } else {

        }
      })
    },
    next () {
      this.form.validateFields(['money'], { force: true }, (err, value) => {
        console.log(err)
        if (err) {
          return false
        }

        this.$api.assets.taxCalculation(value).then(res => {
          if (res.status === 'ok') {
            this.info = res.data
            this.tax_money = res.data.tax_money
            this.money = res.data.money
            this.real_money = res.data.real_money
            this.currentProcess += 1
          }
        })
      })
    },
    prev () {
      this.currentProcess -= 1
    },
    getCode () {
      if (this.codeState.isSend) {
        return false
      }
      const params = {
        phone: this.userInfo.phone,
        type: 1 // 1普通验证码  2注销验证码
      }

      this.$api.user.getVerifyCode(params).then(res => {
        if (res.message.key === 1006) {
          window.tncode.show()
          window.tncode.onSendResult((tn_check, key) => {
            this.$api.user.getVerifyCode(Object.assign(params, { tn_check, key })).then(res => {
              if (res.status === 'ok') {
                this.$message.success('发送成功')
                this.codeState.isSend = true
                this.timer = setInterval(() => {
                  this.codeState.time -= 1
                  if (this.codeState.time === 0) {
                    this.codeState.time = 60
                    this.codeState.isSend = false
                    clearInterval(this.timer)
                  }
                }, 1000)
                window.tncode.hide()
              } else {
                window.tncode._showmsg(res.message.message)
              }
            })
          })
        } else if (res.message.key === 10000) {

        } else {
          this.codeState.isSend = true
          this.timer = setInterval(() => {
            this.codeState.time -= 1
            if (this.codeState.time === 0) {
              this.codeState.time = 60
              this.codeState.isSend = false
              clearInterval(this.timer)
            }
          }, 1000)
        }
      })
    },
    submit () {
      this.form.validateFields((err, values) => {
        if (err) {
          return false
        }
        const params = {
          real_money: this.real_money,
          tax_money: this.tax_money,
          money: this.money,
          code: values.code,
          phone: this.userInfo.phone
        }
        this.$api.assets.withdrawaloperation(params).then(res => {
          if (res.status === 'ok') {
            this.$router.push({
              path: '/manageUser/assets?active=withdraw'
            })
          } else {
            if (res.message.key === 1007) {
              this.form.setFields({
                code: {
                  errors: [new Error(`*${res.message.message}`)]
                }
              })
            }
          }
        })
      })
    },
    checkDraw (rule, value, callback) {
      if (value && value - 0 > this.assets.property - 0) {
        callback(new Error('提现金额不可大于可提现金额'))
      } else {
        callback()
      }
      // if (value && value - 0 < 100) {
      //   callback(new Error('提现金额不可小于100元'))
      // } else if (value && value - 0 > this.assets.property - 0) {
      //   callback(new Error('提现金额不可大于可提现金额'))
      // } else {
      //   callback()
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.withdraw{
  background-color: #ffffff;
  min-height: 800px;

  .title {
    color: @primary-color;
    font-size: 14px;
    padding: 17px 0 17px 24px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content {
    padding: 36px 8px;
    /deep/
    .ant-form-item-control{
      display: block;
      p {
        margin-bottom: 0;
      }
    }
     /deep/
    .ant-form-item-control {
      display: flex;
      align-items: center;
      .ant-form-explain {
        margin-left: 16px;
      }
    }
    .meter{
      font-size: 18px;
    }
    .money {
       font-size: 36px;
      color: #333333;
      font-weight: bold;
      line-height: 26px;
    }

    /deep/
    .ant-tabs-nav .ant-tabs-tab{
      transition: none;
    }
    /deep/
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
      background: none;
      margin-right: 0px;
      border: none;
    }
    /deep/
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
      border: 1px solid #F2F2F2;
      border-radius: 8px 8px 0px 0px;
          border-bottom: 1px solid #fff;
    }
    /deep/
    .ant-table-thead th{
      border-bottom: 2px solid @primary-color ;
    }
    /deep/
    .ant-table-placeholder{
      border-top: none;
      min-height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #999999;
    }

  }

}
</style>
